import AIImageManager from './AIImageManager';
import AIImageElement from './AIImageElement';
import type { AIImageConfig } from './types';

// Register custom element
if (typeof window !== 'undefined' && !customElements.get('ai-img')) {
  customElements.define('ai-img', AIImageElement);
}

// Export main API
export const AIImage = {
  config(config: Partial<AIImageConfig>): void {
    const manager = AIImageManager.getInstance();
    manager.setConfig(config);
  },

  getConfig(): AIImageConfig {
    const manager = AIImageManager.getInstance();
    return manager.getConfig();
  }
};

// Export types
export type { AIImageConfig, GenerateImageParams, AIImageElementAttributes } from './types';

// Default export
export default AIImage;
